module.exports = __webpack_public_path__ + "static/og-5ffa64d77929f69da27464646d398d85.png";